<template>
  <b-modal
      id="fba-barcode-modal"
      ref="fba-barcode-modal"
      hide-footer
      hide-header
      size="lg"
      @hidden="handHiden"
      @shown="handShown"
  >
    <b-button class="pull-right" variant="success" @click="print">Yazdır</b-button>
    <div id="printArea" class="fba-barcode-print">
        <div class="book"
            v-for="(selectedBasketitem, index) in printableBasketItems"
            :key="`${selectedBasketitem.id}-${index}`"
        >
            <div class="page">
                <div class="subpage2">
                    <VueBarcode :value="selectedBasketitem.fn_sku" height="100" width="2"/>
                    <div class="productName">{{ selectedBasketitem.product.name }}</div>
                    <div class="productBarcode">
                        {{ selectedBasketitem.product.barcode }} - {{ selectedBasketitem.az_product.merchant_sku }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <b-button class="pull-right" variant="success" @click="print">Yazdır</b-button>
  </b-modal>
    </template>

<script>
import { mapGetters } from 'vuex';
import VueBarcode from 'vue-barcode';
export default {
    name: 'FbaBarcode',
    components: {
        VueBarcode
    },
    computed: {
       ...mapGetters('azFbaBasket', ['_baskets', '_selectedBasketitems']),
       printableBasketItems() {
           return this._baskets.reduce((items, selectedBasketitem) => {
               if (!this._selectedBasketitems.includes(selectedBasketitem.id)) {
                   return items;
               }

               const amount = Number(selectedBasketitem.amount) || 0;

               for (let index = 0; index < amount; index += 1) {
                   items.push(selectedBasketitem);
               }

               return items;
           }, []);
       },
    },
    methods: {
        handHiden() {
            this.$store.commit('azFbaBasket/setSelectedBasketitems', [])
        },
        async handShown() {
            await this.$htmlToPaper('printArea');
        },
        async print() {
        await this.$htmlToPaper('printArea');
        }
    }
}
</script>

<style scoped>
.fba-barcode-print .book { page-break-after: always; }
.fba-barcode-print .page { display:flex; align-items:center; justify-content:center; min-height:50mm; }
.fba-barcode-print .subpage2 { display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; gap:4px; width: calc(50mm - 4mm); box-sizing: border-box; padding: 4mm 2mm; }
.fba-barcode-print .productName { margin-top: 4px; font-size: 12px; word-break: break-word; }
.fba-barcode-print .productBarcode { font-size: 11px; line-height:1.1; }
@media print {
    .fba-barcode-print .book { break-after: page; }
}
</style>